import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles,
  Slide,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import React, {useEffect, useRef, useState} from 'react';
import * as yup from 'yup';
import {Formik, FormikProps} from 'formik';
import Loading from "../../UiComponents/Loading";
import PlayerPair from "../../../Domain/Models/PlayerPair";
import { playerPairRepository } from '../../../Domain/Repositories/PlayerPairRepository';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  dialog: {
    alignItems: 'flex-start',
  },
  deleteFlex: {
    flex: 1,
  }
}));

export interface PlayerPairModalProps
{
  open: boolean;
  onClose: () => void;
  playerPair: PlayerPair;
}

export default function PlayerPairModal(props: PlayerPairModalProps)
{
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { open, onClose, playerPair } = props;
  const classes = useStyles();

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string>();

  const formRef = useRef<FormikProps<PlayerPair>>(null);

  const schema = yup.object().shape({
  });

  const handleSubmit = (value: PlayerPair) =>
  {
    setSubmitting(true);
    setSubmitError(undefined);

    playerPairRepository.update(value)
      .then(() => onClose())
      .catch((e: Error) =>
      {
        setSubmitting(false);
        setSubmitError(e.message);
      });
  }

  useEffect(() =>
  {
    if (open)
    {
      setSubmitError(undefined);
      setSubmitting(false);
    }
  }, [open]);

  return (
    <Dialog
      classes={{scrollPaper: classes.dialog}}
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown
      disableBackdropClick={submitting}
      TransitionComponent={Transition}
    >
      <DialogTitle>{`${playerPair.name}`}</DialogTitle>

      <Loading isLoading={submitting}>
        <DialogContent>
          <Formik<PlayerPair>
            initialValues={playerPair}
            onSubmit={(value) => handleSubmit(value)}
            validationSchema={schema}
            innerRef={formRef}
          >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur
              }) => (
              <>
                <FormControl fullWidth margin="normal" error={touched.name && errors.name !== undefined}>
                  <InputLabel htmlFor="component-error">Name</InputLabel>
                  <Input
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}/>
                  <FormHelperText>{touched.name && errors.name}</FormHelperText>
                </FormControl>
              </>
            )}
          </Formik>

          {submitError != undefined && (
            <Typography component="h3" variant="subtitle1" color="error" gutterBottom>
              {submitError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose} color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => formRef.current?.handleSubmit()}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>

      </Loading>
    </Dialog>
  );
}